<template>
	<V id="home"/>
</template>
<script>
export default {  };
</script>
